import { createAsyncThunk } from '@reduxjs/toolkit';

import { clearSwitchUserCache } from './switchUserCache';

export const resetUser = createAsyncThunk(
  'user/resetUser',
  async (_, { rejectWithValue }) => {
    try {
      clearSwitchUserCache();
      return true;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
